import { render, staticRenderFns } from "./HeaderCategories.vue?vue&type=template&id=02442fa4&scoped=true&"
import script from "./HeaderCategories.vue?vue&type=script&lang=js&"
export * from "./HeaderCategories.vue?vue&type=script&lang=js&"
import style0 from "./HeaderCategories.vue?vue&type=style&index=0&id=02442fa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02442fa4",
  null
  
)

export default component.exports